/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'

import { deleteRNLTD } from '../../../../assets/ts/data/rnltd'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import useRNLTDMetadata from '../../../../hooks/use-RNLTD-metadata'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { MetadataContext } from '../../../../store/metadata-context-provider'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import AddEditView from './add-edit-view'

const RNLTD = (props: any) => {
  const { RNLTDMetadata, RNLTDMetadataIsLoading, fetchRNLTDMetdata } = useRNLTDMetadata({
    isArchived: null,
  })
  const [showAddPopup, setshowAddPopup] = useState(false)
  const [clickedItem, setClickedItem] = useState<boolean>(false)
  const [sortedData, setSortedData] = useState<any>([])
  const [rnltdCount, setRNLTDCount] = useState(0)
  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  const [allRNLTD, setAllRNLTD] = useState<number[]>([])
  const addEditValue = (showAddPopup: any) => {
    setshowAddPopup(showAddPopup)
  }
  const [showEdit, setEdit] = useState(false)
  /* Function call on edit */
  const onEdit = (item: any) => {
    setInEditMode({
      rowKey: item.eKey,
      status: true,
    })
    setEdit(!showEdit)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setEdit(!showEdit)
    setshowAddPopup(false)
  }

  const onDelete = async (item: any) => {
    setClickedItem(item)
    setshowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }
  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      setClickedItem(false)
      await deleteRNLTD(item)
      await fetchRNLTDMetdata()
    } else {
      setClickedItem(false)
    }
  }

  useEffect(() => {
    const sorted = RNLTDMetadata?.sort((a, b) => {
      if (!a?.ItemModified) return 1
      if (!b?.ItemModified) return -1
      return b.ItemModified.localeCompare(a.ItemModified)
    })
    setSortedData(sorted)
    const allrnltd = sorted.map((rnltd) => rnltd.IntervalDuration)
    const nonArchivedRNLTD = sorted.filter((rnltd) => rnltd.IsArchived === false)
    setAllRNLTD(allrnltd)
    setRNLTDCount(nonArchivedRNLTD?.length || 0)
  }, [RNLTDMetadata])

  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center'>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setshowAddPopup(!showAddPopup)
                }}
              />
            </div>
          </div>
        }
        name='RNLTD'
      />
      <div className='p-0 settings-main mt-2'>
        {showAddPopup && (
          <AddEditView
            allRNLTD={allRNLTD}
            cancel={() => onCancel()}
            editItems={null}
            fetchMetdata={fetchRNLTDMetdata}
            filtersvalue={addEditValue}
            rnltdCount={rnltdCount}
            showAddPopup={showAddPopup}
            toggleView={() => setClickedItem(false)}
          />
        )}
        {sortedData?.map((rnltd, index) => (
          <div
            className='d-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-2'
            key={rnltd.eKey}
          >
            <div className='d-flex px-2'>
              <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                <div aria-live='polite' className='d-flex flex-column  col my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>Interval Type</div>
                  <div className='poppins-semibold font-12 title-color2'>{rnltd.IntervalType}</div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-250 w-100 max-w-250 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Interval Duration</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {rnltd.IntervalDuration}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column  min-w-250 w-100 max-w-250 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Interval Frequency</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {rnltd.IntervalFrequency}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-100 w-100 max-w-80 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Is Archived</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {rnltd.IsArchived ? 'Yes' : 'No'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
              </div>
              <div className='d-flex align-items-center'>
                <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                  <Buttons
                    aria-label='Edit'
                    className={
                      inEditMode.status && inEditMode.rowKey === rnltd.eKey
                        ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                        : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    }
                    icon='icon-pencil me-xl-1 font-10'
                    label='Edit'
                    onClick={() => onEdit(rnltd)}
                  />
                  <Buttons
                    aria-label='Delete'
                    className='btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    icon='icon-trashbin me-xl-1 font-10'
                    label='Delete'
                    onClick={() => onDelete(rnltd)}
                  />
                </div>
              </div>
            </div>
            {inEditMode.status && inEditMode.rowKey === rnltd.eKey ? (
              <AddEditView
                allRNLTD={allRNLTD}
                cancel={() => onCancel()}
                clickedIndex={index}
                editItems={rnltd}
                fetchMetdata={fetchRNLTDMetdata}
                filtersvalue={addEditValue}
                rnltdCount={rnltdCount}
                showAddPopup={showAddPopup}
                showEdit={showEdit}
                toggleView={() => setClickedItem(false)}
              />
            ) : (
              ''
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
export default RNLTD
